import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as actions from '../actions/micustomeractions'
import Select from 'react-select';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import * as constant from '../constants'
import { Search } from '@mui/icons-material';
export default function SearchQuote() {

    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    var masters = state.masters;
    let newEnq = state.basicInfoNewEnq;
    let search = state.quoteSearchParams;
    let quoteSearchResult = state.quoteSearchResult;
    let modalState = state.modalState;

    const handleQuoteSearchChange = (e) => {
        let { name, value } = e.target;
        dispatch(actions.handleQuoteSearchChange({ name, value }));
    }

    const onViewCurrentQuote = async (result) => {
        await dispatch(actions.toggleSearch(!modalState.showSearch));
        await dispatch(actions.getQuoteInformation(result));

        dispatch(actions.handleBasicInfoQuoteChange({ name: "enquiryId", value: result?.quoteId }));
        dispatch(actions.handleBasicInfoQuoteChange({ name: "encryptedEnquiryRefId1", value: result?.encryptedEnquiryRefId1 }));
        dispatch(actions.handleBasicInfoQuoteChange({ name: "encryptedEnquiryRefId2", value: result?.encryptedEnquiryRefId2 }));
        dispatch(actions.handleBasicInfoQuoteChange({ name: "quotationNo", value: result?.quoteId }));

        // if (name == "visaEmirate") {
        //     dispatch(actions.updateProductSelectionParams({ name:"", value:"" }));
        // }

    }

    function renderSearchResult() {
        console.log(quoteSearchResult);
        return (
            <div className="table-responsive">
                <table className="table table-hover table-custom">
                    <thead className="table-header">
                        <tr>
                            <th>Enquiry No </th>
                            <th>Quote No</th>
                            <th>Stage</th>
                            <th>Status</th>

                            <th>Action</th>
                        </tr>
                    </thead>
                    {quoteSearchResult?.length != 0 ? (
                        <tbody>
                            {quoteSearchResult?.map((result, index) => (
                                <tr key={index} className="table-row">
                                    <td> {result.enqNo} </td>
                                    <td> {result.quoteNo} </td>
                                    <td> {result.stage} </td>
                                    <td> {result.status}</td>
                                    <td> <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" onClick={() => onViewCurrentQuote(result)}
                                    >
                                        <i className="dripicons-preview"></i>
                                    </button></td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" >
                                    <div className="alert alert-warning">No Results Found...</div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>

        );
    }
    let QuoteNo = <input
        name='quoteNo'
        id='quoteNo'
        type="text"
        className={errors.quoteNo ? "form-control is-invalid" : "form-control"}
        {...register("quoteNo", { required: !search?.enqNo ? "Quote No/Enquiry No is required" : '', onChange: (e) => handleQuoteSearchChange(e) })}

    />

    let EnqNo = <input
        name='enqNo'

        id='enqNo'
        type="text"
        className={errors.enqNo ? "form-control is-invalid" : "form-control"}

        {...register("enqNo", {
            required: !search?.quoteNo ? "Quote No/Enquiry No is required" : '',
            onChange: (e) => handleQuoteSearchChange(e)
        })}

    />
    let MobileNo = <input
        name='mobileNo'
        id='mobileNo'
        type="text"
        className={errors.mobileNo ? "form-control is-invalid" : "form-control"}

        {...register("mobileNo", {
            validate: (value) => {
                if (/*!search?.quoteNo &&*/ !value && !search?.email) {
                    return "Mobile/Email is required";
                }
                return true;
            }, onChange: (e) => handleQuoteSearchChange(e)
        })}

    />
    let EmailId = <input
        name='email'
        id='email'
        type="text"
        className={errors.email ? "form-control is-invalid" : "form-control"}

        {...register("email", {
            validate: (value) => {
                if (/*!search?.quoteNo &&*/ !value && !search?.mobileNo) {
                    return "Mobile/Email is required";
                }
                return true;
            }, onChange: (e) => handleQuoteSearchChange(e)
        })}

    />
    const onSearchSubmit = async (data) => {
        console.log('Form Data:', state.quoteSearchParams);


        await dispatch(actions.getQuoteSearchResult(state.quoteSearchParams))

    };
    const onSearchErrors = async (data) => {
        console.log('Form Data:', state.basicInfoNewEnq);
        //  await dispatch(actions.saveMICustomerEnquiry(state.basicInfoNewEnq))

    };
    return (<>


        <form onSubmit={handleSubmit(onSearchSubmit, onSearchErrors)}>
            <div className="mt-2" >
                <div className="container">
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-4 text-start">
                                <label htmlFor="visaEmirate" className="form-label w-100">  Quote Number</label>
                            </div>
                            <div className="col-8">
                                {QuoteNo}
                                {errors.quoteNo && <p className="text-danger fst-italic fs-6">{errors.quoteNo.message}</p>}
                                <div>

                                </div>

                            </div>


                        </div>

                    </div>

                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-4 text-start">
                                <label htmlFor="sponsorName" className="form-label w-100">  Enquiry Number</label>
                            </div>
                            <div className="col-8">
                                {EnqNo}
                                {errors.enqNo && <p className="text-danger fst-italic fs-6">{errors.enqNo.message}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-4 text-start">
                                <label htmlFor="mobile" className="form-label w-100">  Mobile</label>
                            </div>
                            <div className="col-8">
                                {MobileNo}
                                {errors.mobileNo && <p className="text-danger fst-italic fs-6">{errors.mobileNo.message}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-4 text-start">
                                <label htmlFor="email" className="form-label w-100">  Email</label>
                            </div>
                            <div className="col-8">
                                {EmailId}
                                {errors.email && <p className="text-danger fst-italic fs-6">{errors.email.message}</p>}

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>

                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    startIcon={<Search />}


                >
                    Search
                </Button>
            </Box>
        </form>
        <div className="row">
            {renderSearchResult()}
        </div>
    </>);
}

